import React from 'react';
import AppointmentInvoiceManagement from '../components/health/AppointmentInvoiceManagement';

const AppointmentInvoicePage: React.FC = () => {
  return (
    <div style={{ padding: 'var(--erp-spacing-lg)' }}>
      <AppointmentInvoiceManagement />
    </div>
  );
};

export default AppointmentInvoicePage;